import { Injectable } from '@angular/core';
import { WorkflowDataProvider } from '@services/workflow/workflow.data.service';

@Injectable()
export class WorkflowDragNDropProvider {
	constructor(private workflowDataService: WorkflowDataProvider) {}

	replaceFirstWithSecond(list): Array<any> {
		const [first, second, ...rest] = list;
		return [second, first, ...rest];
	}

	replaceLastWithPrevious(list): Array<any> {
		const modifiedList = list;
		const last = modifiedList.pop();
		modifiedList.splice(modifiedList.length - 1, 0, last);
		return modifiedList;
	}

	isDefaultTaskInPlace(list, isLastSection = false): boolean {
		let checkedTask;
		const firstTask = list[0];
		const lastTask = list[list.length - 1];

		checkedTask = isLastSection ? lastTask : firstTask;

		const eventType = checkedTask.eventType || checkedTask.calendarEventType;
		if (checkedTask.defaultTask && eventType !== 'MAIN_SHOOT') {
			return true;
		}
		return false;
	}

	checkForChangeType(item, taskTypes): string {
		const numberOfTasksOfEachType = taskTypes.map(item => item.length);
		const [leadNum, productionNum] = numberOfTasksOfEachType;

		const firstNumInLastSection = leadNum + productionNum;
		if (item.number >= firstNumInLastSection) {
			return 'POST_PRODUCTION';
		} else if (item.number >= leadNum) {
			return 'PRODUCTION';
		}
		return 'LEAD';
	}

	renewTaskList(taskTypesList): Array<any> {
		const taskTypes = JSON.parse(JSON.stringify(taskTypesList));
		let num = 0;
		taskTypes.forEach(taskType => {
			taskType.forEach(task => {
				task.number = num;
				task.type = this.checkForChangeType(task, taskTypes);

				if (task.dateSequence === 'after previous task') {
					if (num != 0) {
						task.previousTask = num - 1;
					}
				} else if (task.previousTask || task.previousTask === 0) {
					delete task.previousTask;
				}
				num++;
			});
		});

		return taskTypes;
	}

	keepDefaultTasksInPlace(taskTypesArr): Array<any> {
		const taskTypes = JSON.parse(JSON.stringify(taskTypesArr));
		const numberOfTaskTypes = taskTypes.length;

		taskTypes.forEach((type, index, typesArr) => {
			const lastElement = index === numberOfTaskTypes - 1;

			if (lastElement) {
				const isOrderCorrect = this.isDefaultTaskInPlace(type, true);
				if (!isOrderCorrect) {
					typesArr[index] = this.replaceLastWithPrevious(type);
				}
			} else {
				const isOrderCorrect = this.isDefaultTaskInPlace(type);
				if (!isOrderCorrect) {
					typesArr[index] = this.replaceFirstWithSecond(type);
				}
			}
		});

		return taskTypes;
	}

	getTaskById(task2Search, taskTypes) {
		const task = JSON.parse(JSON.stringify(task2Search));
		const isTaskId = task.id !== null && task.id !== undefined;

		const identificator = isTaskId ? 'id' : 'tmpId';

		if (!task[identificator]) {
			return false;
		}

		for (let i = 0, max = taskTypes.length; i < max; i++) {
			const taskType = taskTypes[i];
			const foundTask = taskType.find(
				taskInList => task[identificator] === taskInList[identificator]
			);

			if (foundTask) {
				return foundTask;
			}
		}
	}

	checkForEqualNumbers(taskTypes): boolean {
		const tasksArray = [].concat.apply([], taskTypes);
		const uniqueNumbers = [
			...Array.from(new Set(tasksArray.map(a => a.number)))
		];
		const isAllNumbersUnique = uniqueNumbers.length === tasksArray.length;
		return !isAllNumbersUnique;
	}

	prepareTask2Save(draggedTask, taskTypes) {
		const newTaskInfo = this.getTaskById(draggedTask, taskTypes); // position in array with new numbers&types

		if (!newTaskInfo) {
			return false;
		}

		const isMainShootInWrongPlace =
			newTaskInfo.calendarEventType === 'MAIN_SHOOT' &&
			newTaskInfo.type !== 'PRODUCTION';

		if (isMainShootInWrongPlace) {
			return false;
		}

		if (newTaskInfo.overdueDays) {
			newTaskInfo.overdueDays = parseInt(
				newTaskInfo.overdueDays.match(/\d+/)[0],
				10
			);
		}

		const { number, type, id, overdueDays } = newTaskInfo;

		return {
			number,
			type,
			id,
			overdueDays
		};
	}

	saveNewTasksOrder(draggedTask, taskTypes) {
		let taskListCopy = JSON.parse(JSON.stringify(taskTypes)); // original array
		taskListCopy = this.renewTaskList(taskListCopy); // array with changed numbers+types

		const task2save = this.prepareTask2Save(draggedTask, taskListCopy);

		if (!task2save) {
			return false;
		}

		const {
			number: currentNumber,
			type: currentType,
			id,
			overdueDays
		} = task2save;

		const isPositionChanged =
			draggedTask.number !== currentNumber || draggedTask.type !== currentType;

		if (!isPositionChanged) {
			return false;
		}

		return this.workflowDataService.saveNewTasksOrder(
			id,
			currentNumber,
			currentType,
			overdueDays
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/workflow/workflow-drag-n-drop.ts